// src/components/PlayerName.js
import React from 'react';
import './PlayerName.css';

/**
 * PlayerName Component
 *
 * A reusable component for displaying player names with role indicators.
 * Handles room owner (⭐), judge (⚖️), and bot (🤖) indicators.
 *
 * @param {Object} props
 * @param {Object} props.player - Player object with id, username/name, and isBot properties
 * @param {string} props.roomCreatorPlayerId - ID of the room creator
 * @param {boolean} props.isJudge - Whether this player is the current Judge
 * @param {string} props.className - Additional CSS classes
 * @param {boolean} props.showBot - Whether to show bot indicator (default: true)
 * @param {boolean} props.showOwner - Whether to show owner indicator (default: true)
 * @param {boolean} props.showCzar - Whether to show czar indicator (default: true)
 */
function PlayerName({
  player,
  roomCreatorPlayerId,
  isJudge = false,
  className = '',
  showBot = true,
  showOwner = true,
  showCzar = true,
}) {
  if (!player) return null;

  const playerName = player.username || player.name || 'Unknown Player';
  const playerId = player.id || player.playerId;
  const isRoomOwner = playerId === roomCreatorPlayerId;

  return (
    <span className={`player-name-display ${className}`}>
      <span className="player-name-text">{playerName}</span>
      {showOwner && isRoomOwner && (
        <span className="player-indicator owner-indicator" title="Room Owner">
          {' '}
          ⭐
        </span>
      )}
      {showCzar && isJudge && (
        <span className="player-indicator czar-indicator" title="Judge">
          {' '}
          ⚖️
        </span>
      )}
      {showBot && player.isBot && (
        <span className="player-indicator bot-indicator" title="Bot Player">
          {' '}
          🤖
        </span>
      )}
    </span>
  );
}

export default PlayerName;
